<template>
	<v-tooltip bottom :open-on-hover="false">
		<template #activator="{ on }">
			<v-btn text small @click="on.click" @blur="on.blur" retain-focus-on-click color="grey darken-2">
				Last updated
				<v-icon small right>mdi-update</v-icon>
			</v-btn>
		</template>

		<div v-if="typeof statsData === 'string'">
			<h3>{{ statsData }}</h3>
		</div>

		<div v-else>
			<div>
				<h3>Stats</h3>
				<div v-for="item in stats" :key="item.id">
					<strong>{{ item.name }}</strong
					>: {{ item.date }}
				</div>
			</div>

			<br />

			<div>
				<h3>Prices</h3>
				<div v-for="item in prices" :key="item.id">
					<strong>{{ item.name }}</strong
					>: {{ item.date }}
				</div>
			</div>
		</div>
	</v-tooltip>
</template>

<script>
	/**
	 * @module Tooltip
	 *
	 * @vue-data {object|string} statsData - Data about stats and prices
	 * @vue-computed {string} stats - Get stats data
	 * @vue-computed {string} prices - Get prices data
	 */

	export default {
		name: 'Tooltip',
		data() {
			return {
				statsData: localStorage.getItem('user')
					? JSON.parse(localStorage.getItem('user')).stats_data
					: 'Not available',
			};
		},
		computed: {
			stats() {
				return this.statsData.stats;
			},
			prices() {
				return this.statsData.prices;
			},
		},
	};
</script>
